// extracted by mini-css-extract-plugin
module.exports = {"OralChineseEvaluation":"OralChineseEvaluation___e5bIN","inner":"inner___1U8mw"};